import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Number2 = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step2-line-a"
          d="M12 4a8 8 0 100 16 8 8 0 000-16zm0 1.333a6.667 6.667 0 110 13.334 6.667 6.667 0 010-13.334zM14.93 16v-1.396h-3.422v-.076l1.01-.95c.673-.616 1.143-1.09 1.41-1.424.267-.333.464-.658.59-.975.128-.316.191-.656.191-1.017 0-.416-.103-.785-.311-1.107a2.074 2.074 0 00-.876-.752c-.376-.179-.809-.268-1.3-.268-.372 0-.708.036-1.01.11a3.53 3.53 0 00-.832.314c-.254.136-.574.369-.961.698l.902 1.07c.312-.259.61-.457.897-.597a2 2 0 01.886-.21c.29 0 .522.077.696.231.174.154.26.389.26.704 0 .211-.039.415-.118.612a2.705 2.705 0 01-.386.642c-.18.231-.56.646-1.144 1.244L9.44 14.845V16h5.49z"
        ></path>
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="step2-line-b" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#step2-line-a"></use>
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#step2-line-a"
        ></use>
        <g
          fill={props.color || theme.palette.grey600}
          mask="url(#step2-line-b)"
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
    >
      <defs>
        <path
          id="step2-solid-a"
          d="M12 4a8 8 0 110 16 8 8 0 010-16zm2.93 12v-1.396h-3.422v-.076l1.01-.95c.673-.616 1.143-1.09 1.41-1.424.267-.333.464-.658.59-.975.128-.316.191-.656.191-1.017 0-.416-.103-.785-.311-1.107a2.074 2.074 0 00-.876-.752c-.376-.179-.809-.268-1.3-.268-.372 0-.708.036-1.01.11a3.53 3.53 0 00-.832.314c-.254.136-.574.369-.961.698l.902 1.07c.312-.259.61-.457.897-.597a2 2 0 01.886-.21c.29 0 .522.077.696.231.174.154.26.389.26.704 0 .211-.039.415-.118.612a2.705 2.705 0 01-.386.642c-.18.231-.56.646-1.144 1.244L9.44 14.845V16h5.49z"
        ></path>
      </defs>
      <g fill={props.color || theme.palette.grey600} fillRule="evenodd">
        <mask id="step2-solid-b" fill={props.color || theme.palette.grey600}>
          <use xlinkHref="#step2-solid-a"></use>
        </mask>
        <use
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#step2-solid-a"
        ></use>
        <g
          fill={props.color || theme.palette.grey600}
          mask="url(#step2-solid-b)"
        >
          <path d="M0 0h24v24H0z"></path>
        </g>
      </g>
    </svg>
  );
